import { render } from "./FrameSubsection.vue?vue&type=template&id=fffab244&scoped=true"
import script from "./FrameSubsection.vue?vue&type=script&lang=js"
export * from "./FrameSubsection.vue?vue&type=script&lang=js"

import "./FrameSubsection.vue?vue&type=style&index=0&id=fffab244&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fffab244"]])

export default __exports__